export default {
    methods: {
        genericJsonIsValidJson(json) {
            try {
                JSON.parse(json)
            } catch (e) {
                return false
            }
            return true
        },

        /**
         *
         * Validates and parses a JSON string.
         * If valid, returns the parsed object.
         * If invalid, optionally logs the error along with context.
         *
         * @param {string} json - The JSON string to validate and parse.
         * @param {boolean|object} logAndContext - If true, enables logging without context.
         *                                         If an object, enables logging with context as the object.
         * @returns {object|null} - Parsed JSON object if valid, otherwise null.
         *
         */
        genericJsonValidateAndParse(json, logAndContext = false) {

            try {
                return JSON.parse(json);
            } catch (e) {
                if (logAndContext) {
                    const logMessage = {
                        error: e.message,
                        jsonSnippet: json?.substring(0, 200), // Log a snippet for large JSON
                    };

                    // Add context if it's an object
                    if (typeof logAndContext === "object") {
                        logMessage.context = logAndContext;
                    }

                    console.error("Invalid JSON:", logMessage);
                }
                return null;
            }

        }
    }
}
